import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "DocumentLegal" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }

import { PropType } from "vue";
import { Company, Document } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLegal',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    company: {
        type: Object as PropType<Company>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("b", null, _toDisplayString(__props.company.name), 1),
      _cache[0] || (_cache[0] = _createTextVNode(" | ")),
      (__props.document.english)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "CoC:"))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, "KvK:")),
      _createTextVNode(" " + _toDisplayString(__props.company.coc) + " | ", 1),
      (__props.document.english)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "VAT:"))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, "BTW:")),
      _createTextVNode(" " + _toDisplayString(__props.company.vat), 1)
    ]),
    _createElementVNode("div", null, " Bank: " + _toDisplayString(__props.company.bankName) + " " + _toDisplayString(__props.company.bankAddress) + " | IBAN: " + _toDisplayString(__props.company.iban) + " | BIC: " + _toDisplayString(__props.company.bic), 1)
  ]))
}
}

})